import './tripDetails.css';
import DetailsImageDisplay from '../../components/detailsImageDisplay/DetailsImageDisplay';
import TripBookingTab from './tripBookingTab/TripBookingTab';
import DetailsTabs from '../../components/detailsTabs/DetailsTabs';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import ReactLoading from 'react-loading';
import moment from 'moment';
import fetchTripData from './tripDetailsFun/fetchTripData';
import ReviewStars from '../../components/reviewStars/ReviewStars';
import { ReactComponent as Share } from '../../assets/icons/trvto_share.svg';
import { share } from './tripDetailsFun/tripDetailsShare';
import fetchTripCheck from './tripCheckFun/tripCheck';
import { userReview } from '../../api/userAPI';
import { UserAuthContext } from '../../context/UserAuthContext';
import { ReactComponent as CloseIcon } from '../../assets/icons/trvto_close.svg';
import EmptyPage from '../../components/empty-page/emptyPage';
import { getFormattedDate } from '../../utils/formatDate';
import { handleWishlistClick } from '../../utils/wishlistHandler';
import { fetchWishlistData } from '../../components/tripCard/getUserWishlist/getUserWishlist';
import { UserLoginSecContext } from '../../context/UserLoginSecContext';
import { ReactComponent as LoveBlack } from '../../assets/icons/trvto_wishlist.svg';
import { ReactComponent as LoveRed } from '../../assets/icons/trvto_favorite.svg';
import { ReactComponent as RatingStar } from '../../assets/icons/trvto_rating-star.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import TripCard from '../../components/tripCard/TripCard';
// import { ReactComponent as LeftArrow } from '../../assets/icons/trvto_left_arrow_icon.svg';
// import { ReactComponent as RightArraow } from '../../assets/icons/trvto_right_arrow_icon.svg';
import { getInterestedTrips, getInterestedTripsOrg } from '../../api/infoAPI';
import { clearBookingStorage } from '../../utils/clearStorage';
import DetailsTab from '../../components/orgDetails/detailsTab/DetailsTab';
import formatedTripData from '../../components/tripCard/formatTripData/formatTripData';
import ListingCard from '../../components/tripCard/listingCard/ListingCard';
import logo from '../../assets/images/trvto-logo.png';
import { trackEvent } from '../../utils/analytics';
import VoiceSummary from '../../components/voiceSummary/VoiceSummary';
import { tripVoiceScript } from '../../components/voiceSummary/tripVoiceScript';

export default function TripDetails() {
    const isMobile = window.innerWidth < 768;
    const [packData, setPackData] = useState({});
    const [packDates, setPackDates] = useState([]);
    // spoken summary for the "Listen to trip summary" button
    const voiceScripts = useMemo(
        () =>
            packData?._id
                ? { en: tripVoiceScript(packData, packDates, 'en'), kn: tripVoiceScript(packData, packDates, 'kn') }
                : null,
        [packData, packDates]
    );
    const [loading, setLoading] = useState(false);
    const [popupVisible, setPopupVisible] = useState(true);
    const [userWishlist, setUserWishlist] = useState([]);
    const [checkTrip, setCheckTrip] = useState(false);
    const [userRating, setUserRating] = useState(0);
    const [popupRating, setPopupRating] = useState(userRating);
    const [typeSel, setTypeSel] = useState('trip');
    const [comment, setComment] = useState('');
    const [isFavourite, setIsFavourite] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const { isAuthenticated } = useContext(UserAuthContext);
    const location = useLocation();
    const { setLogButton, setLoginSec } = useContext(UserLoginSecContext);
    const packId = useRef(window.location.pathname.split('/')[3]);
    const type = useRef(
        window.location.pathname.split('/')[1] === 'org'
            ? window.location.pathname.split('/')[2]
            : window.location.pathname.split('/')[1]
    );
    const appOnlyPopupShown = useRef(false);
    const tripStatus = location.state?.tripStatus;
    const [showAppOnlyPopup, setShowAppOnlyPopup] = useState(false);
    const [allowedDates, setAllowedDates] = useState([]);
    const navigate = useNavigate();
    const [interestedTrips, setInterestedTrips] = useState([]);
    const { id } = JSON.parse(localStorage.getItem('tempOrg')) || {};
    const USER_IDS = ['686f837afe8ded032c47991a', '6892ebe235b0fc3f961f5146', '6a2269bb48c4821d006de9c6'];
    const userId = localStorage.getItem('userId');
    const context = {
        role: 'user',
        flow: 'trip'
    };

    useEffect(() => {
        clearBookingStorage();
        setTypeSel((prev) => prev);
        fetchTripData(type.current, packId.current, setLoading, setPackData, setPackDates);
    }, []);

    useEffect(() => {
        if (!packData?._id) return;

        trackEvent({
            event: 'trip_view',

            page: window.location.pathname + window.location.search,

            tripId: packData._id,

            metadata: {
                tripTitle: packData?.title || null,
                destination: packData?.quickView?.destination || null,
                organizerId: packData?.organizerId || null
            }
        });
    }, [packData?._id]);

    useEffect(() => {
        if (!isAuthenticated) return;
        fetchWishlistData(typeSel, setUserWishlist);
        fetchTripCheck(type.current, packId.current, setCheckTrip);
    }, [typeSel, isAuthenticated]);

    useEffect(() => {
        setIsFavourite(userWishlist?.includes(packData._id));
    }, [userWishlist, packData?._id]);

    useEffect(() => {
        if (packDates.length !== 0) {
            setAllowedDates(
                packDates.map(function (obj) {
                    return moment(obj.startDate);
                })
            );
        }
    }, [packDates]);

    useEffect(() => {
        appOnlyPopupShown.current = false;
    }, [packData?._id]);

    useEffect(() => {
        if (packData?.appOnly === true && !appOnlyPopupShown.current) {
            setShowAppOnlyPopup(true);
            appOnlyPopupShown.current = true;
        }
    }, [packData?.appOnly]);

    const handleSubmitRating = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const ratingData = {
            packId: packId.current,
            userName: localStorage.getItem('name'),
            userId: localStorage.getItem('userId'),
            rating: popupRating,
            organizerId: packData.organizerId,
            comment
        };
        await userReview(typeSel, ratingData);
        setUserRating(popupRating);
    };

    const handleWishlist = () => {
        if (isAuthenticated) {
            handleWishlistClick(packData._id, userWishlist, typeSel, setUserWishlist);
        } else {
            setLogButton(true);
            setLoginSec('login');
        }
    };

    useEffect(() => {
        if (!type || !packId) {
            return;
        }
        const fetchIntrestedTrips = async () => {
            try {
                const result = id
                    ? await getInterestedTripsOrg(type.current, id)
                    : await getInterestedTrips(type.current, packId.current);
                if (result?.data) {
                    const tripData = result?.data || [];
                    setInterestedTrips(tripData);
                }
            } catch (error) {
                console.error('Error fetching interested trips:', error);
            }
        };
        fetchIntrestedTrips();
    }, [type, packId, id]);

    const carouselRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const updateScrollButton = () => {
        const el = carouselRef.current;
        if (!el) return;

        const scrollLeft = Math.round(el.scrollLeft);
        const maxScrollLeft = el.scrollWidth - el.clientWidth;

        const canScrollLeftNow = scrollLeft > 0;
        const canScrollRightNow = scrollLeft < maxScrollLeft - 1;

        setCanScrollLeft(canScrollLeftNow);
        setCanScrollRight(canScrollRightNow);
    };

    const scrollLeft = () => {
        const el = carouselRef.current;
        if (!el) return;
        const scrollAmount = el.clientWidth;
        el.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        setTimeout(updateScrollButton, 300);
    };

    const scrollRight = () => {
        const el = carouselRef.current;
        if (!el) return;
        const scrollAmount = el.clientWidth;
        el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        setTimeout(updateScrollButton, 300);
    };

    useEffect(() => {
        const scrollEl = carouselRef.current;
        if (!scrollEl) return;

        const handleUpdate = () => updateScrollButton();

        scrollEl.addEventListener('scroll', handleUpdate);

        // Run after layout to get correct dimensions
        setTimeout(updateScrollButton, 0);

        return () => scrollEl.removeEventListener('scroll', handleUpdate);
    }, [interestedTrips]);

    const baseCities = packData?.quickView?.baseCities;
    const startCityLocation =
        typeof baseCities === 'string' && baseCities.trim()
            ? baseCities.split(',').map((city) => city.trim())
            : Array.isArray(baseCities)
              ? baseCities
              : [];

    const closePopup = () => setPopupVisible(false);

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            {Object.keys(packData).length !== 0 ? (
                <>
                    <div className='tripDetailsLayout'>
                        <div className='tripDetailsMainRow'>
                            <div className='tripDetailsLeft'>
                                <div className='tripDetailsHeadingDivUser'>
                                    <div className='detailsImageDisplayNameUser'>
                                        <div>
                                            <div className='detailsImageDisplayNameUser'>
                                                <span className='titleTrip'>{packData?.title || 'N/A'}</span>

                                                {/* <button className='addToWishlistButton' onClick={handleWishlist}>
                                        {isFavourite ? 'Remove from' : 'Add to'} Wishlist
                                    </button> */}
                                            </div>
                                            <div>
                                                <div className='tripBriefInfo'>
                                                    {USER_IDS.includes(userId) && (
                                                        <>
                                                            <span
                                                                className='tripDetailsSubDetails'
                                                                style={{ fontSize: 'small' }}
                                                            >
                                                                By
                                                            </span>
                                                            <span
                                                                className='tripDetailsSubDetails'
                                                                // onClick={() => {
                                                                //     navigate(`/h/orgid/${packData?.organizerId}`);
                                                                // }}
                                                            >
                                                                {packData?.organizerName}
                                                            </span>
                                                            <span className='tripDetailsDot'></span>
                                                        </>
                                                    )}
                                                    <span className='tripDetailsSubDetails'>
                                                        {packData?.days + 'D/' + packData?.nights + 'N'}
                                                    </span>
                                                    {!isMobile && (
                                                        <>
                                                            <span className='tripDetailsDot'></span>
                                                            <span className='tripDetailsSubDetails'>
                                                                {packDates?.length !== 0 &&
                                                                    getFormattedDate(packDates[0].startDate)}{' '}
                                                                Onwards
                                                            </span>
                                                        </>
                                                    )}

                                                    <span className='tripDetailsDot'></span>
                                                    <span className='tripDetailsSubDetails'>
                                                        From:{' '}
                                                        {Array.isArray(startCityLocation) &&
                                                        startCityLocation.length > 3
                                                            ? startCityLocation.slice(0, 3).join(',')
                                                            : startCityLocation.join(',')}
                                                    </span>
                                                    <span
                                                        className='tripRatings'
                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                    >
                                                        {/* <ReviewStars rating={packData?.rating || 0} /> */}
                                                        <RatingStar style={{ marginRight: '4px' }} />
                                                        <span>{packData?.rating || 0}</span>
                                                        {/* <p style={{ margin: 0 }}>({packData?.reviewCount || 0} Reviews)</p> */}
                                                    </span>
                                                    {/* <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>{packData?.quickView?.startTime}</span>
                                <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>{packData?.quickView?.stay}</span>
                                <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>{packData?.quickView?.food}</span>
                                <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>{packData?.quickView?.type[0]}</span>
                                <span className='tripDetailsDot'></span>
                                <span className='tripDetailsSubDetails'>{packData?.quickView?.difficulty}</span>
                                <span className='tripDetailsDot'></span> */}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='icons'>
                                            {/* reads a short summary of the trip aloud (device voice);
                                                on phones it sits on its own row under the title instead */}
                                            {voiceScripts && !isMobile && (
                                                <VoiceSummary scripts={voiceScripts} variant='icon' />
                                            )}
                                            {isFavourite ? (
                                                <LoveRed className='wishlist-icon-trip-user' onClick={handleWishlist} />
                                            ) : (
                                                <LoveBlack
                                                    className='wishlist-icon-trip-user'
                                                    onClick={handleWishlist}
                                                />
                                            )}
                                            <Share className='share-icon-trip-user' onClick={(e) => share(e)} />
                                        </div>
                                    </div>
                                    {voiceScripts && isMobile && (
                                        <div className='tripVoiceRow'>
                                            <VoiceSummary scripts={voiceScripts} variant='icon' />
                                        </div>
                                    )}
                                </div>
                                <DetailsImageDisplay
                                    imageData={packData.images}
                                    videoData={packData.videos}
                                    stayImages={packData?.stayDetails?.images}
                                />
                                {/* <DetailsTabs
                                    tripDetailsData={packData}
                                    isExpanded={isExpanded}
                                    setIsExpanded={setIsExpanded}
                                    typeSel={typeSel}
                                    packDates={packDates}
                                /> */}
                                <DetailsTab context={context} data={packData} dates={packDates} />
                            </div>
                            <div className='tripDetailsBookingUser'>
                                <TripBookingTab
                                    packData={packData}
                                    setPackData={setPackData}
                                    allowedDates={allowedDates}
                                    packDates={packDates}
                                    setLoading={setLoading}
                                    isExpanded={isExpanded}
                                    setIsExpanded={setIsExpanded}
                                    setShowAppOnlyPopup={setShowAppOnlyPopup}
                                />
                            </div>
                        </div>
                        {interestedTrips && interestedTrips.length > 0 && !isMobile && (
                            <>
                                <div className='carousel'>
                                    <p className='carousel-header'>You might be interested in</p>
                                </div>
                                <div className='carousel-container'>
                                    {canScrollLeft && (
                                        <button className='modalNavButton left' onClick={scrollLeft}>
                                            ‹
                                        </button>
                                    )}
                                    <div className='searchResultContentAreaTrip' ref={carouselRef}>
                                        <TripCard imageData={interestedTrips} interested={true} type={typeSel} />
                                        {/* {interestedTrips.map((dataItem) => {
                                            const formattedData = formatedTripData(dataItem, type);
                                            const isFavorite = Array.isArray(userWishlist)
                                                ? userWishlist.includes(dataItem._id)
                                                : false;
                                            return (
                                                <ListingCard
                                                    key={formattedData?._id}
                                                    type={'trip'}
                                                    {...formattedData}
                                                    isFavorite={isFavorite}
                                                />
                                            );
                                        })} */}
                                    </div>
                                    {canScrollRight && (
                                        <button className='modalNavButton right' onClick={scrollRight}>
                                            ›
                                        </button>
                                    )}
                                </div>
                            </>
                        )}
                        {isMobile && (
                            <>
                                <div className='carousel'>
                                    <p className='carousel-header'>You might be interested in</p>
                                </div>
                                <div className='carousel-container'>
                                    {canScrollLeft && (
                                        <button className='modalNavButton left' onClick={scrollLeft}>
                                            ‹
                                        </button>
                                    )}
                                    <div className='searchResultContentAreaTrip' ref={carouselRef}>
                                        <TripCard imageData={interestedTrips} interested={true} type={typeSel} />
                                    </div>
                                    {canScrollRight && (
                                        <button className='modalNavButton right' onClick={scrollRight}>
                                            ›
                                        </button>
                                    )}
                                </div>
                            </>
                        )}
                        {isAuthenticated &&
                            (tripStatus === 'In Progress' || tripStatus === 'Completed') &&
                            checkTrip?.data?.status &&
                            popupVisible && (
                                <div className='ratingModal'>
                                    <div className='modalContent'>
                                        <div className='ratingHeader'>
                                            <h3>Rate Your Previous Trip</h3>
                                            <CloseIcon onClick={closePopup} className='loginCloseIcon' />
                                        </div>
                                        <ReviewStars
                                            rating={popupRating}
                                            onRatingChange={(newRating) => setPopupRating(newRating)}
                                            isInteractive
                                        />
                                        <textarea
                                            value={comment}
                                            onChange={(e) => setComment(e.target.value)}
                                            onClick={(e) => e.stopPropagation()}
                                            placeholder='Add your comments here...'
                                            className='commentBox'
                                        />
                                        <div className='modalActions'>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleSubmitRating(e);
                                                }}
                                                className='submitRating'
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                        {showAppOnlyPopup && packData?.appOnly === true && (
                            <div className='appOnlyOverlay'>
                                <div className='appOnlyPopup'>
                                    <button className='appOnlyClose' onClick={() => setShowAppOnlyPopup(false)}>
                                        ×
                                    </button>

                                    <div className='appOnlyIcon'>
                                        {' '}
                                        <img alt='trvto logo' src={logo} className='headerLogoImg' />
                                    </div>

                                    <h2>Available on TRVTO App</h2>

                                    <p>This trip is available only on the TRVTO mobile app.</p>

                                    <button
                                        className='appOnlyButton'
                                        onClick={() => {
                                            window.location.href = `https://trvto.com/trip/${packData?._id}`;
                                        }}
                                    >
                                        Open in App
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            ) : (
                <EmptyPage />
            )}
        </div>
    );
}
